import React from "react";

const WorkProcessThree = () => {
  return (
    <>
      {/* Work Process area start */}
      <section className="process__area-4 pt-150 pb-150">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="process__title-wrap-3">
                <h2
                  className="sec-subtitle"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
     SECURITR YYS GÜVENLİK EĞİTİMİ
                </h2>
                <h3 className="sec-title heading-animation">
                GÜVENLİKTE YETKİNLİK VE KALİTE İÇİN SECURITR'NİN GÜVENCESİ
                </h3>
              </div>
              <div className="process__list-4">
                <div
                  className="process__item-4"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <div className="serial">01</div>
                  <div className="process__content-4">
                    
                    <p>
                    SecuriTR, güvenlik sektöründe uzmanlaşmış bir firma olarak YYS güvenlik eğitimi sunmaktadır.
                    </p>
                  </div>
                </div>
                <div
                  className="process__item-4"
                  data-aos="fade-up"
                  data-aos-delay={400}
                >
                  <div className="serial">02</div>
                  <div className="process__content-4">
              
                    <p>
                    YYS müfredatının istediği Narkotik Maddelerin Tespiti / Nükleer, Biyolojik, Kimyasal (NBC) Maddelerin Tespiti / Kaçakçılık, Araç Zula Kontrol, Konteynır 7 Noktalı Kontrol / Yanıcı ve Patlayıcı Maddelerin Tespiti
                    </p>
                  </div>
                </div>
                <div
                  className="process__item-4"
                  data-aos="fade-up"
                  data-aos-delay={500}
                >
                  <div className="serial">03</div>
                  <div className="process__content-4">
 
                    <p>
                    Eğitim kapsamı bir YYS alanının izinsiz girişlere kapatılarak steril kalmasını sağlamak ve devamlılıktır.
                    </p>
                  </div>
                </div>
                <div
                  className="process__item-4"
                  data-aos="fade-up"
                  data-aos-delay={600}
                >
                  <div className="serial">04</div>
                  <div className="process__content-4">
             
                    <p>
                    YYS süreçleri kapsamında her 3 yılda bir yapılan denetimlere uygun olarak eğitim takvimleri yenilenir.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Work Process area end */}
    </>
  );
};

export default WorkProcessThree;
